import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';
import pipeP from 'ramda/src/pipeP';
import ifElse from 'ramda/src/ifElse';
import prop from 'ramda/src/prop';
import pipe from 'ramda/src/pipe';
import { inlineEditorHtml, stripHtmlString } from '../../common/helpers/browser';
import { showNotification } from '../../common/helpers/notifications';
import SaveDraft from '../components/SaveDraft';
import { saveCampaign, updateCampaign, redirectToCampaignCharge } from '../actions';
import { getActiveType } from '../../auth/selectors';
import { getCampaign } from '../selectors';
import confirmModal from '../../common/confirmModal';
import { t } from '../../../modules/infra/i18n';

const SaveDraftContainer = compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      campaignId: ownProps.params.campaignId,
      campaign: getCampaign(state),
      activeType: getActiveType(state),
    }),
    {
      saveCampaign,
      updateCampaign,
      redirectToCampaignCharge,
    }
  ),
  withState('disabled', 'setDisabled', false),
  withHandlers({
    showConfirmModal: (props) => async () => {
      const confirmed = await confirmModal({
        title: t('engage:errors.confirm'),
        // eslint-disable-next-line max-len
        message: t('engage:errors.copy_subject_message'),
        type: 'defaultSafe',
        confirmButtonText: t('engage:errors.review_send_button'),
        negativeButtonText: t('engage:errors.cancel'),
      });

      if (!confirmed) {
        props.setDisabled(false);
        return;
      }

      return true;
    },
  }),
  withHandlers({
    sendCampaign: props => async () => {
      props.setDisabled(true);

      const { subject } = props.campaign;
      const formatHtml = pipe(inlineEditorHtml, stripHtmlString);
      const formattedString = subject ? formatHtml(subject) : '';
      const isEmptySubject = !subject || !(formattedString.trim());
      const isTooLong = formattedString.length > 60;

      const subjectWithoutHtml = subject?.replace(/<[^>]*>?/g, '');
      const isCopy = subjectWithoutHtml?.startsWith('COPY');

      if (isCopy) {
        const isConfirmed = await props.showConfirmModal();
        if (!isConfirmed) {
          return;
        }
      }

      if (isEmptySubject) {
        showNotification({
          title: t('engage:errors.error'),
          message: t('engage:errors.empty_subject'),
        });

        props.setDisabled(false);

        return;
      }

      if (isTooLong) {
        showNotification({
          title: t('engage:errors.error'),
          message: t('engage:errors.subject_too_long'),
        });

        props.setDisabled(false);

        return;
      }

      try {
        const result = await pipeP(
          ifElse(
            prop('campaignId'),
            pipe(prop('campaign'), props.updateCampaign),
            pipe(prop('campaign'), props.saveCampaign),
          ),
          campaign => props.redirectToCampaignCharge(campaign, props.activeType)
        )(props);

        return result;
      } finally {
        props.setDisabled(false);
      }
    },
  }),
)(SaveDraft);

export default SaveDraftContainer;
